import { SubmissionStatuses } from '../types';

/** Total used as the denominator for percentage = (count / total) * 100 */
const TOTAL_SUBMISSIONS = 100;

export const SUBMISSION_STATUSES_MOCK: SubmissionStatuses = {
  total_submissions: TOTAL_SUBMISSIONS,
  statuses: [
    {
      status: 'Complete',
      count: 30,
      percentage: Math.round((40 / TOTAL_SUBMISSIONS) * 100 * 100) / 100, // 40
    },
    {
      status: 'Draft',
      count: 20,
      percentage: Math.round((14 / TOTAL_SUBMISSIONS) * 100 * 100) / 100, // 14
    },
    {
      status: 'Pre-Review',
      count: 30,
      percentage: Math.round((20 / TOTAL_SUBMISSIONS) * 100 * 100) / 100, // 20
    },
    {
      status: 'Review',
      count: 20,
      percentage: Math.round((20 / TOTAL_SUBMISSIONS) * 100 * 100) / 100, // 20
    },
  ],
};
